import { MODULE } from "./childCardFilter.actionTypes";

export const getShowChildCards = (state) => state.getIn([MODULE, "showChildCards"]);

export default {};
